import { FormattedMessage, useIntl } from 'react-intl'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import BodyText from 'LuxKit/Typography/BodyText'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import Group from 'components/utils/Group'

interface Props {
  inclusions: Array<App.PackageInclusion>
  bundleInclusions?: Array<App.OfferInclusion>
  loyaltyInclusions?: Array<App.OfferInclusion>
}

export function HotelSummaryInclusions({ inclusions, bundleInclusions, loyaltyInclusions }: Props) {
  const intl = useIntl()
  const bonusInclusions = inclusions.filter(inclusion => inclusion.isBonus)
  const regularInclusions = inclusions.filter(inclusion => !inclusion.isBonus)
  const hasBonusInclusions = bonusInclusions.length > 0
  const hasBundleInclusions = !!bundleInclusions?.length

  return (
    <VerticalSpacer gap={12}>
      {(regularInclusions.length > 0 || hasBundleInclusions) && (
        <div>
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="7TkY0OrBDIS8K1W86dK-"
              defaultMessage="Package inclusions:"
              description="Label for the list of items included in the hotel package"
            />
          </BodyText>
          <Group direction="vertical" gap={4}>
            {bundleInclusions?.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted colour="exclusive" iconSize="S" />)}
            {regularInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={inclusion.isHighlighted} iconSize="S" />)}
            {!hasBonusInclusions && <LoyaltyInclusions inclusions={loyaltyInclusions} variant="offer-page" />}
          </Group>
        </div>
      )}
      {hasBonusInclusions && (
        <div>
          <BodyText variant="medium" weight="bold" format="propercase">{intl.formatMessage({
            id: 'QHEyfbSSWAYmH81kVqvg',
            defaultMessage: 'Extra inclusions:',
            description: 'Label for bonus inclusions list in hotel summary inclusions section',
          })}
          </BodyText>
          <Group direction="vertical" gap={4}>
            {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} iconSize="S" />)}
            <LoyaltyInclusions inclusions={loyaltyInclusions} variant="offer-page" />
          </Group>
        </div>
      )}
    </VerticalSpacer>
  )
}
